import { RadiomarkComponent } from './Radiomark'
import { StyledRadiomark } from './Radiomark.styles'

export type { RadiomarkElementProps } from './Radiomark'

export const Radiomark = Object.assign(RadiomarkComponent, {
  Styled: {
    StyledRadiomark,
  },
})
